import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import api from "../../../api";
import "../../Grid/grid.css";
import "./OutboundCampaign.css";
import { Segment, Table, Pagination } from "semantic-ui-react";
import { DatatablePageSizeSelect } from "../CompletedChats/DatatablePageSizeSelect";
import OutboundCampaignFilter from "./OutboundCampaignFilter";
import CampaignForm from "./CampaignForm";
import CampaignDetails from "./CampaignDetails";
import ConfirmationModal from "../Workspace/Botbuilder/Details/confusedbranch/DataConnect/ConfirmationModal";
import { handleApiResponse, handleApiError } from '../../../util_funs';
import StatusBadge from "./StatusBadge";
import CampaignActionsDropdown from './CampaignActionsDropdown';
import TrustHubCnamAction from "./TrustHubCnamAction";
import GlobalMessage from "../TrustHub/GlobalMessage";
import { Message } from "semantic-ui-react";
import { setMessage } from "../../../store/Page";
import {
    DUPLICATE_CONTACTS_SKIPPED_TITLE,
    DUPLICATE_SKIP_NOTICE_DISPLAY_MS,
    formatDuplicateSkippedBody,
    getDuplicateSkipWindowDays,
} from './duplicateContactsSkipCopy';

/** Duplicate skip summary — same copy on list and on add/edit form when saves return blocked rows */
function SkippedContactsBanner({ notice, inForm = false }) {
    if (!notice) return null;
    return (
        <Message
            color="red"
            style={{
                maxWidth: '100%',
                ...(inForm ? { marginTop: 0, marginBottom: '1rem' } : { marginTop: 30 }),
            }}
        >
            <Message.Header style={{ marginBottom: '0.5rem' }}>
                {DUPLICATE_CONTACTS_SKIPPED_TITLE}
            </Message.Header>
            <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: 1.55 }}>
                {formatDuplicateSkippedBody(notice.count, notice.windowDays)}
            </p>
        </Message>
    );
}

const tableHeader = [
 {
   title: "Campaign Name",
   width: "3",
   sort: "name",
 },
 {
   title: "Created Date",
   width: "3",
   sort: "created_at",
 },
 {
   title: "Campaign Type",
   width: "3",
 },
 {
   title: "Campaign Category",
   width: "3",
 },
 {
   title: "Send Type",
   width: "3",
 },
 {
   title: "Schedule Type",
   width: "3",
 },
 {
   title: "Start Campaign Date",
   width: "3",
   sort: "start_date",
 },
 {
   title: "Next Campaign Date",
   width: "3",
   sort: "next_execution_date",
 },


 {
   title: "Start Campaign Time",
   width: "3",
 },
 {
   title: "End Campaign Time",
   width: "3",
 },
 // {
 //   title: "Days",
 //   width: "2",
 // },


 {
   title: "Status",
   width: "3",
   sort: "status",
 },
 {
   title: "Total Customers",
   width: "3",
 },
 {
   title: "Workspace Name",
   width: "2",
 },
 {
   title: "Outbound Number",
   width: "3",
 },




 {
   title: "Actions",
   width: "3",
 }
];


const OutboundCampaignList = (props) => {
 const dispatch = useDispatch();
 /** After save/update: generic notice when some contacts were skipped (no per-row dump). */
 const [skippedContactsNotice, setSkippedContactsNotice] = useState(null);
 const skippedNoticeAnchorRef = useRef(null);
 const [cnamStatus, setCnamStatus] = useState(null);
 const [stirStatus, setStirStatus] = useState(null);
 // Function to get status badge with proper styling
 const [state, setState] = useState({
   data: [],
   loading: false,
   totalPages: 0,
   currentPage: 1,
   pageSize: 10,
   sortColumn: "",
   sortDirection: "",
   searchTerm: "",
   showAddModal: false,
   newCampaign: {
     campaign_name: "",
     description: "",
     workspace_id: "",
     contact_list: []
   },
   workspaces: [],
   showForm: false,
   editingCampaign: null,
   deleteModalOpen: false,
   campaignToDelete: null,
   duplicateModalOpen: false,
   campaignToDuplicate: null,
   showDetails: false,
   viewingCampaign: null,
 });
 let statusColor = '';
 const onChangeLimit = (event, data) => {
   if (data.value !== state.pageSize) {
     loadData({ limit: data.value, page: 1 });
   }
 };


 useEffect(() => {
   loadData();
 }, []);
 console.log(props.user?.user_id)
 useEffect(() => {
   fetchTrustStatus();
 }, [props.user?.user_id]);

 useEffect(() => {
   if (!skippedContactsNotice) return;
   const id = window.setTimeout(() => {
     const el = skippedNoticeAnchorRef.current;
     if (el) {
       el.scrollIntoView({
         behavior: 'smooth',
         block: 'start',
         inline: 'nearest',
       });
     }
   }, 120);
   return () => window.clearTimeout(id);
 }, [skippedContactsNotice]);


 const fetchTrustStatus = async () => {
   try {
     if (!props.user?.user_id) return;
     const res = await api.outbound.getTrustProductStatus(parseInt(props.user?.user_id));
     if (res?.status !== false) {
       setCnamStatus(res?.data?.cnam || 'not_created');
       setStirStatus(res?.data?.stir || 'not_created');
     }
   } catch (e) {
     // ignore
   }
 };
 const formatStatus = (status) => {
   if (!status) return '';


   // Map approved statuses to "Completed"
   if (status === 'approved' || status === 'twilio-approved') return 'Completed';
   // Map non_marketing to "General Non-Marketing"
   if (status === 'non_marketing') return 'General Non-Marketing';


   // Otherwise, format normally
   return status
     .replace(/[-_]/g, ' ')
     .replace(/\b\w/g, (char) => char.toUpperCase());
 };


 const isTwilioApproved = props.profileStatus === 'twilio-approved';

 // CNAM
 const showCnamAction =
   ['not_created', 'twilio-rejected', 'draft'].includes(cnamStatus);


 const isCnamEditMode =
   ['twilio-rejected', 'draft'].includes(cnamStatus);


 const shouldShowTrustHubActions = isTwilioApproved && showCnamAction;






 const loadData = async (params = {}) => {
   setState(prevState => ({ ...prevState, loading: true }));
   let u = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
   let clientTimeZone = u.substring(0, 3) + ":" + u.substring(3, u.length);
   try {
     const requestParams = {
       page: params.page || state.currentPage,
       limit: params.limit || state.pageSize,
       sort_column: params.sortColumn || state.sortColumn,
       sort_direction: params.sortDirection || state.sortDirection,
       search: params.search || state.searchTerm,
       campaign_status: params.campaign_status,
       campaign_frequency: params.campaign_frequency,
       timezone: clientTimeZone,
       user_id: props.user?.user_id || props.user?.user_id
     };


     const response = await api.outbound.CampaignsList(requestParams);


     if (response && response.data && response.data.campaigns) {
       setState(prevState => ({
         ...prevState,
         data: response.data.campaigns || [],
         totalPages: response.data.pagination.total ? parseInt(response.data.pagination?.last_page) : 0,
         currentPage: response.data.pagination.total ? parseInt(response.data.pagination?.current_page) : 0,
         loading: false
       }));
     } else {
       setState(prevState => ({ ...prevState, loading: false }));
     }
   } catch (error) {
     console.error("Error loading campaigns:", error);
     setState(prevState => ({ ...prevState, loading: false }));
   }
 };




 const handleSort = (clickedColumn) => {
   const { sortColumn, sortDirection } = state;
   let newDirection = "asc";
   if (sortColumn === clickedColumn) {
     newDirection = sortDirection === "asc" ? "desc" : "asc";
   }
   setState(prevState => ({
     ...prevState,
     sortColumn: clickedColumn,
     sortDirection: newDirection,
   }));


   loadData({
     sortColumn: clickedColumn,
     sortDirection: newDirection,
   });
 };


 const onChangePage = (event, data) => {
   loadData({ page: data.activePage });
 };
 const getTypeBadge = (type) => {
   if (!type) return null;


   const normalizedType = type.toLowerCase();
   const config = { class: 'status-badge badge-primary' };


   const capitalizedText = normalizedType.charAt(0).toUpperCase() + normalizedType.slice(1);


   return <span className={config.class}>{capitalizedText}</span>;
 };


 const getSendTypeDisplay = (sendType) => {
   switch (sendType) {
     case 'now':
       return 'Send Now';
     case 'scheduled':
       return 'Scheduled';
     default:
       return sendType || 'N/A';
   }
 };




 const displayScheduleType = (schedule_type) => {
   switch (schedule_type) {
     case 'one_time':
       return 'One Time';
     case 'ongoing':
       return 'Ongoing';
     default:
       return schedule_type || 'N/A';
   }
 };






 const onSubmitFilter = (filterType, value) => {
   let params = { page: 1 };


   if (filterType === 'q') {
     params.search = value;
   } else if (filterType === 'campaignStatus') {
     params.campaign_status = value;
   } else if (filterType === 'campaignFrequency') {
     params.campaign_frequency = value;
   } else {
     params[filterType] = value;
   }


   loadData(params);
 };


 const onSubmitFilterDateRange = (range) => {
   console.log("Date range applied:", range);
   loadData({
     page: 1,
     ...range
   });
 };


 const handleAddCampaign = () => {
   setSkippedContactsNotice(null);
   setState(prevState => ({
     ...prevState,
     showForm: true,
     editingCampaign: null
   }));
 };


 const handleViewCampaign = (campaign) => {
   setSkippedContactsNotice(null);
   setState(prevState => ({
     ...prevState,
     showDetails: true,
     viewingCampaign: campaign
   }));
 };


 const handleEditCampaign = (campaign) => {
   setSkippedContactsNotice(null);
   setState(prevState => ({
     ...prevState,
     showForm: true,
     editingCampaign: campaign
   }));
 };

 const handleDuplicateCampaign = async (campaign) => {
   if (state.loading) {
     return null;
   }

   setState(prevState => ({
     ...prevState,
     duplicateModalOpen: true,
     campaignToDuplicate: campaign
   }));
 };

 const handleDuplicateConfirm = async () => {
   const { campaignToDuplicate } = state;
   if (!campaignToDuplicate) return null;

   setState(prevState => ({
     ...prevState,
     loading: true,
     duplicateModalOpen: false
   }));

   try {
     const campaignData = { campaign_id: campaignToDuplicate.id };
     const response = await api.outbound.duplicateCampaign(campaignData);

     if (response?.status) {
       dispatch(setMessage({
         type: "success",
         text: response?.message || "Campaign duplicated successfully!"
       }));
       await loadData();
     } else {
       dispatch(setMessage({
         type: "error",
         text: response?.message || "Failed to duplicate campaign."
       }));
     }

     return response;
   } catch (error) {
     dispatch(setMessage({
       type: "error",
       text: error?.response?.data?.message || error?.message || "Failed to duplicate campaign."
     }));
     return null;
   } finally {
     setState(prevState => ({
       ...prevState,
       loading: false,
       campaignToDuplicate: null
     }));
   }
 };

 const handleDuplicateCancel = () => {
   setState(prevState => ({
     ...prevState,
     duplicateModalOpen: false,
     campaignToDuplicate: null
   }));
 };


 /** @param {{ clearSkippedNotice?: boolean }} [opts] — set clearSkippedNotice false after update when skipped duplicates banner should show on the list */
 const handleBackToList = (opts = {}) => {
   const { clearSkippedNotice = true } = opts;
   if (clearSkippedNotice) {
     setSkippedContactsNotice(null);
   }
   setState(prevState => ({
     ...prevState,
     showForm: false,
     editingCampaign: null,
     showDetails: false,
     viewingCampaign: null
   }));
   loadData(); // Refresh the list
 };


 const handleSaveCampaign = async (campaignData) => {
   try {
     let response;
     const isEditing = !!state.editingCampaign;
     if (isEditing) {
       response = await api.outbound.updateCampaign(state.editingCampaign.id, campaignData);
     } else {
       response = await api.outbound.saveCampaign(campaignData);
     }


     if (response.status) {
       // Check if there are blocked customers
       if (response.blocked_customers && response.blocked_customers.length > 0) {
         const list = response.blocked_customers;
         const count = list.length;
         const windowDays = getDuplicateSkipWindowDays(campaignData, list);
         setSkippedContactsNotice({ count, windowDays });
         setTimeout(() => setSkippedContactsNotice(null), DUPLICATE_SKIP_NOTICE_DISPLAY_MS);
       } else {
         setSkippedContactsNotice(null);
       }


       // If creating a new campaign, redirect to detail page
       if (!isEditing) {
         // Use the campaign data from the response directly
         const campaignData = response.data?.campaign || response.data || response.campaign;


         if (campaignData) {
           setSkippedContactsNotice(null);
           // Close the form and show the detail page
           setState(prevState => ({
             ...prevState,
             showForm: false,
             editingCampaign: null,
             showDetails: true,
             viewingCampaign: campaignData
           }));
           return { status: true };
         }
       }
       // After update with skipped duplicates: return to list and show banner there (not on edit form)
       if (
         isEditing &&
         response.blocked_customers &&
         response.blocked_customers.length > 0
       ) {
         handleBackToList({ clearSkippedNotice: false });
         return { status: true };
       }
       handleBackToList();
       return { status: true };
     } else {
       return handleApiResponse(response);
     }
   } catch (error) {
     return handleApiError(error);
   }
 };




 const handleDeleteConfirm = async () => {
   const { campaignToDelete } = state;
   if (!campaignToDelete) return;


   try {
     const response = await api.outbound.deleteCampaign(campaignToDelete.id);
     if (response.status) {
       console.log("Campaign deleted successfully");
       loadData(); // Refresh the list
     } else {
       console.error("Failed to delete campaign:", response.message);
     }
   } catch (error) {
     console.error("Error deleting campaign:", error);
   } finally {
     setState(prevState => ({
       ...prevState,
       deleteModalOpen: false,
       campaignToDelete: null
     }));
   }
 };


 const handleDeleteCancel = () => {
   setState(prevState => ({
     ...prevState,
     deleteModalOpen: false,
     campaignToDelete: null
   }));
 };


 const renderTableHeader = () => {
   return (
     <Table.Header>
       <Table.Row>
         {tableHeader.map((header, index) => (
           <Table.HeaderCell
             key={index}
             style={{ cursor: header.sort ? "pointer" : "default" }}
             onClick={() => header.sort && handleSort(header.sort)}
           >
             {header.title}
             {header.sort && (
               <i
                 className={`fa fa-sort-${state.sortColumn === header.sort
                   ? state.sortDirection === "asc"
                     ? "up"
                     : "down"
                   : ""
                   }`}
                 style={{ marginLeft: "5px" }}
               />
             )}
           </Table.HeaderCell>
         ))}
       </Table.Row>
     </Table.Header>
   );
 };


 const renderTableBody = () => {
   const { data } = state;
   if (!data || data.length === 0) {
     return (
       <Table.Body>
         <Table.Row>
          <Table.Cell colSpan={tableHeader.length} textAlign="center">
             No record found.
           </Table.Cell>
         </Table.Row>
       </Table.Body>
     );
   }


   return (
     <Table.Body>
       {data.map((campaign) => (
         <Table.Row key={campaign.id}>
           <Table.Cell>{campaign.name}</Table.Cell>
           <Table.Cell>{campaign.created_at}</Table.Cell>
           <Table.Cell>{getTypeBadge(campaign.type)}</Table.Cell>
           <Table.Cell>
             {campaign.campaign_category
               ? formatStatus(campaign.campaign_category)
               : "N/A"}
           </Table.Cell>
           <Table.Cell>{getSendTypeDisplay(campaign.send_type)}</Table.Cell>
           <Table.Cell>{displayScheduleType(campaign.schedule?.schedule_type)}</Table.Cell>
           <Table.Cell>{campaign.schedule?.start_date ?? 'N/A'}</Table.Cell>
           <Table.Cell>{campaign.next_execution_date ?? 'N/A'}</Table.Cell>
           <Table.Cell>{campaign.schedule?.start_time ?? 'N/A'}</Table.Cell>
           <Table.Cell>{campaign.schedule?.end_time ?? 'N/A'}</Table.Cell>
           {/* <Table.Cell>
             <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
               {campaign.schedule?.days && campaign.schedule.days.length > 0 ? (
                 campaign.schedule.days.map((day, index) => (
                   <span key={index} >
                     {day}
                   </span>
                 ))
               ) : (
                 <span>N/A</span>
               )}
             </div>
           </Table.Cell> */}
           <Table.Cell><StatusBadge status={campaign.status} /></Table.Cell>
           <Table.Cell>{campaign.customers?.length || 0}</Table.Cell>
           <Table.Cell>{campaign.workspace_name ?? 'N/A'}</Table.Cell>
          <Table.Cell>{campaign.outbound_number?.phone ?? 'N/A'}</Table.Cell>
           <Table.Cell>
             <CampaignActionsDropdown
               campaign={campaign}
               handleViewCampaign={handleViewCampaign}
               handleEditCampaign={handleEditCampaign}
               onStatusChanged={() => loadData()}
               onWorkingChange={(isWorking) => setState(prev => ({ ...prev, loading: isWorking }))}
               profileStatus={props.profileStatus}
               stirStatus={stirStatus}
               handleDuplicateCampaign={handleDuplicateCampaign}
             />
           </Table.Cell>
         </Table.Row>
       ))}
     </Table.Body>
   );
 };
 const { loading, totalPages, currentPage, showForm, editingCampaign, showDetails, viewingCampaign } = state;

 // Show details if showDetails is true
 if (showDetails) {
   return (
     <div style={{
       margin: '0 auto',
       padding: '20px',
       backgroundColor: 'white',
       borderRadius: '8px',
       boxShadow: 'none',
       border: 'none'
     }}>
       <CampaignDetails
         campaign_id={viewingCampaign?.id}
         workspace_id={props.user?.workspace_id}
         user_id={props.user?.user_id}
         onBackToList={handleBackToList}
         onEditCampaign={handleEditCampaign}
       />
     </div>
   );
 }


 // Show form if showForm is true (duplicate-skip summary is shown on the listing page only)
 if (showForm) {
   return (
     <div style={{
       margin: '0 auto',
       padding: '20px',
       backgroundColor: 'white',
       borderRadius: '8px',
       boxShadow: 'none',
       border: 'none'
     }}>
       <CampaignForm
         workspace_id={props.user?.workspace_id}
         user_id={props.user?.user_id}
         campaign_id={editingCampaign?.id}
         editingCampaign={editingCampaign}
         onSave={handleSaveCampaign}
         onCancel={handleBackToList}
         compactMode={true}
       />
     </div>
   );
 }


 // Show list view
 return (
   <>
     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px', padding: '0 20px' }}>
       <div style={{ flex: 1 }}>
         <OutboundCampaignFilter
           onSubmitFilter={onSubmitFilter}
           onSubmitFilterDateRange={onSubmitFilterDateRange}
           totalCount={state.data.length}
         />


       </div>


       <div style={{ marginLeft: '20px' }}>
         <button
           className="linear-gradient yr-submitbtn btn-sm"
           onClick={handleAddCampaign}
         >
           <i className="la la-plus"></i>
           Add Campaign
         </button>
       </div>
       {shouldShowTrustHubActions && (
         <div style={{ display: 'flex', alignItems: 'center', marginLeft: 12 }}>
           {showCnamAction && (
             <TrustHubCnamAction
               isEditMode={isCnamEditMode}
             />
           )}


         </div>
       )}
     </div>
     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 20px' }}>
       {props.profileStatus !== 'twilio-approved' && (
         <p>
           <strong style={{ color: '#d9534f' }}>Note:</strong> Campaigns can be created, but they won’t run until the SHAKEN/STIR profile status is complete.
         </p>
       )}


       {/* If stirStatus is NOT approved AND profileStatus IS approved → show warning note. */}
       {stirStatus && stirStatus !== 'twilio-approved' && props.profileStatus === 'twilio-approved' && (
         <p style={{ margin: 0 }}>
           <strong style={{ color: '#d9534f' }}>Note:</strong> Campaigns can be created, but they won’t run until the SHAKEN/STIR Attestation status is complete.
         </p>
       )}






     </div>


     {skippedContactsNotice ? (
       <div ref={skippedNoticeAnchorRef}>
         <SkippedContactsBanner notice={skippedContactsNotice} inForm={false} />
       </div>
     ) : null}
     <GlobalMessage />
     {loading && <div className="ui loading form"></div>}
     <Segment style={{ width: "calc(100vw - 100px)", overflowX: "auto" }}>
       {loading && <div className="ui loading form"></div>}
       <Table ui celled selectable sortable table>
         {renderTableHeader()}
         {renderTableBody()}
       </Table>
     </Segment>
     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
       <div style={{ display: 'flex', alignItems: 'center' }}>
         <DatatablePageSizeSelect
           limit={state.pageSize.toString()}
           onChangeLimit={onChangeLimit}
         />
         <span style={{ marginLeft: '10px' }}>
           Showing 1 - {state.pageSize.toString()} of {state.data.length}
         </span>
       </div>
       <div>
         <Pagination
           totalPages={totalPages}
           activePage={currentPage}
           onPageChange={onChangePage}
         />
       </div>
     </div>


     <ConfirmationModal
       open={state.deleteModalOpen}
       onClose={handleDeleteCancel}
       onConfirm={handleDeleteConfirm}
     />
     <ConfirmationModal
       open={state.duplicateModalOpen}
       onClose={handleDuplicateCancel}
       onConfirm={handleDuplicateConfirm}
       title="Duplicate Campaign"
       content={`Are you sure you want to duplicate the campaign "${state.campaignToDuplicate?.name || state.campaignToDuplicate?.campaign_name || ""}"?`}
       cancelLabel="No"
       confirmLabel="Yes"
     />
   </>
 );
};


export default OutboundCampaignList;
